<template>
  <div class="error">
    <div class="error__wrapper">
      <div class="error__body">
        <p class="error__title typography__headline3">{{ title }}</p>

        <p class="error__description typography__body2">{{ description }}</p>
      </div>

      <div class="error__footer">
        <BaseLink
          v-if="showHomeButton"
          class="base-button-big base-button-first"
          :href="url"
          @click="() => onClickHandler()"
        >
          {{ $i18n.t("common.error.goToHome") }}
        </BaseLink>

        <BaseLink
          v-if="showLogoutButton"
          class="base-button-big base-button-second"
          :to="createAppLink('/client/projects', 'main')"
        >
          {{ $i18n.t("common.errors.goToProjects") }}
        </BaseLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { $i18n } = useNuxtApp();
const { createAppLink } = useAppLink();

interface Props {
  description: string;
  title: string;
  url?: string;
  showLogoutButton?: boolean;
  needToReloadPage?: boolean;
  showHomeButton?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  url: "/",
  showLogoutButton: false,
  needToReloadPage: false,
  showHomeButton: true,
});

console.log(props);

const onClickHandler = async () => {
  if (props.needToReloadPage) {
    await navigateTo(props.url, { replace: true });
  } else {
    await clearError({
      redirect: props.url,
    });
  }
};
</script>

<style scoped>
.error {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: var(--grey-7);
}

.error__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 24px;
  width: 100%;
  height: 100%;
  padding: 38px;
  text-align: center;
}

@media (--desktop) {
  .error__wrapper {
    row-gap: 40px;
    width: 100%;
    max-width: 600px;
    height: 100%;
    max-height: 600px;
    border-radius: 50%;
    background-color: var(--white);
  }
}

.error__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
}

@media (--desktop) {
  .error__title {
    font-weight: 400;
    font-size: 44px;
    line-height: 1.18;
  }
}

@media (--desktop) {
  .error__description {
    font-size: 16px;
  }
}

.error__footer {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
</style>
